<div *ngIf="isBlogDataLoaded && isMainPostLoaded" class="narrowed-container">
  <div class="row">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div
        *ngIf="post"
        [dataLayerParamsClickGA4]="dataLayerParamsClickGA4"
        appStaticAdClick
        appStaticRedirectClick
        class="content-pages-single-container prose mt-4"
        id="content-pages-single-container"
      >
        <h1 [innerHTML]="post.title.rendered"></h1>
        <div
          *ngIf="post && post.acf && post.acf.sponsoredDescription !== ''"
          [innerHtml]="post.acf.sponsoredDescription"
          class="caption"
        ></div>
        <div class="content-pages-single-date">
          <app-ui-icon color="var(--grey-1)" name="clock" size="sm"></app-ui-icon>
          <span>{{ updateDate }}</span>
          <span
            *ngIf="postTags && postTags.length > 0"
            [innerHTML]="postTagsString"
          ></span>
        </div>
        <div
          [innerHtml]="
                          post.excerpt.rendered
                            | wpMediaUrlFix
                            | wpAnchorLinksUrlFix
                            | safeHtml
                        "
          appAddClickActionToLocalLinks
          class="content-pages-single-description mb-4"
        ></div>
        <div
          [ngStyle]="{'padding-bottom': imageContainerPadding}"
          class="content-pages-single-image"
        >
          <app-media-item
            [image]="post.acf.mainImage"
            [isPriority]="true"
          ></app-media-item>
        </div>
        <div
          [innerHtml]="
                          post.content.rendered
                            | wpMediaUrlFix
                            | wpAnchorLinksUrlFix
                            | safeHtml
                        "
          appAddClickActionToLocalLinks
          class="content-pages-single-content"
        ></div>

        <app-author-block
          *ngIf="isPostAuthorsBlockVisible"
          [authorName]="post.acf.authorName"
          [author]="post.acf.author"
          [factChecker]="post.acf.factChecker"
          [publishDate]="publishDateFull"
          [updateDate]="updateDateFull"
        ></app-author-block>

        <section
          *ngIf="commentsTotal > 0"
          class="content-pages-single-comments-section"
        >
          <p
            *ngIf="commentsTotal > 0"
            class="content-pages-single-comments-count"
          >
            {{ commentsTotal }} {{ wpService.getCommentsHeader(commentsTotal) }}
          </p>

          <div
            *ngFor="let comment of comments; trackBy: trackByMethodComments"
            class="content-pages-single-comment"
          >
            <div
              *ngIf="comment.parent === 0"
              class="content-pages-single-comment-box"
            >
                            <span class="content-pages-single-comment-date">{{
                                wpService.getFormattedDate(comment.date)
                              }}</span>
              <p class="content-pages-single-comment-author">
                {{ comment.author_name }} skrev:
              </p>
              <div [innerHTML]="comment.content['rendered']"></div>
              <a (click)="commentReply(comment.id, comment.author_name)"
              >svara</a
              >

              <div
                *ngFor="
                                let subComment of comments;
                                trackBy: trackByMethodSubcomments
                              "
                class="content-pages-single-comment"
              >
                <div
                  *ngIf="subComment.parent === comment.id"
                  class="content-pages-single-comment-box"
                >
                                <span class="content-pages-single-comment-date">{{
                                    wpService.getFormattedDate(subComment.date)
                                  }}</span>
                  <p class="content-pages-single-comment-author">
                    {{ subComment.author_name }} skrev:
                  </p>
                  <div [innerHTML]="subComment.content['rendered']"></div>
                  <a (click)="commentReply(comment.id, subComment.author_name)"
                  >svara</a
                  >
                </div>
              </div>
            </div>
          </div>
        </section>

        <section *ngIf="post.comment_status === commentStatusEnum.OPEN">
          <h3>Skriv kommentar</h3>

          <div *ngIf="isCommentSuccessMsgVisible" class="success-message">
            <p>
              Tack för din kommentar. Det kommer att publiceras efter
              godkännande av moderatoren.
            </p>
          </div>

          <div *ngIf="commentReplyName !== ''">
            <p>
              <b
              >Du svarar på {{ commentReplyName }},
                <a (click)="cancelCommentReply()">avbryt</a></b
              >
            </p>
          </div>

          <form
            [formGroup]="form"
            class="content-pages-single-comment-form not-prose"
            id="comment-form"
          >
            <mat-form-field appearance="outline">
              <input
                formControlName="name"
                matInput
                placeholder="Uppge endast ditt förnamn (obligatoriskt)"
              >
              <mat-error *ngIf="form.controls.name.hasError('required')">
                Ditt förnamn <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <input
                formControlName="email"
                matInput
                placeholder="Din e-postadress (publiceras ej)"
              >
              <mat-error
                *ngIf="
                                form.controls.email.hasError('email') &&
                                !form.controls.email.hasError('required')
                              "
              >
                Ange en giltig e-postadress
              </mat-error>
              <mat-error *ngIf="form.controls.email.hasError('required')">
                E-postadress <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                            <textarea
                              formControlName="content"
                              matInput
                              placeholder="Kommentar"
                            ></textarea>
              <mat-error *ngIf="form.controls.content.hasError('required')">
                Kommentar <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
            <mat-checkbox color="primary" formControlName="datapolicy">
              Jag har läst och accepterar
              <a
                [routerLink]="termsRouterLink"
                target="_blank"
              >allmänna villkor</a
              >
              och
              <a
                [routerLink]="privacyRouterLink"
                target="_blank"
              >integritetspolicy</a
              >
            </mat-checkbox>
            <mat-error
              *ngIf="
                              form.controls.datapolicy.hasError('pattern') &&
                              form.controls.datapolicy.touched
                            "
              class="privacy-accept-error"
            >
              För att skicka in din kommentar måste du godkänna Allmänna villkor
              och vår Integritetspolicy.
            </mat-error>

            <mat-checkbox color="primary" formControlName="commentpolicy">
              Jag har läst och accepterar
              <a
                [routerLink]="commentPolicyRouterLink"
                target="_blank"
              >policy for bloggkommentarer</a
              >
            </mat-checkbox>
            <mat-error
              *ngIf="
                              form.controls.commentpolicy.hasError('pattern') &&
                              form.controls.commentpolicy.touched
                            "
              class="privacy-accept-error"
            >
              För att skicka in din kommentar måste du godkänna vår policy för
              bloggkommentarer.
            </mat-error>

            <app-ui-button
              (onClick)="postComment()"
              [color]="'green'"
              [compressed]="false"
              [expanded]="'block'"
              [size]="'lg'"
              class="test-blog-add-comment-btn"
            >
              Skicka
            </app-ui-button>
          </form>
        </section>

        <section
          *ngIf="showRelatedSection && isMainPostLoaded"
          class="related-posts"
        >
          <h4 class="small-header-title">Relaterade blogginlägg</h4>
          <aside>
            <div class="small-puffs">
              <app-blog-puffs-list
                (puffsNumberUpdated)="onPuffsNumberUpdate($event)"
                [excludeId]="post.id"
                [puffsLimit]="relatedPostsPuffsLimit"
                [tags]="post.blogtag"
              ></app-blog-puffs-list>
            </div>
          </aside>
        </section>
      </div>
    </div>

    <div class="col-s">
      <app-blog-taxonomy-box
        *ngIf="
          isBlogDataLoaded &&
          isMainPostLoaded &&
          isCommentSeectionLoaded &&
          isRelatedPostsLoaded
        "
        [tags]="tags"
      ></app-blog-taxonomy-box>
      <app-sidebar
        *ngIf="post"
        [isAdVisible]="true"
        [pageType]="pageType"
      ></app-sidebar>
    </div>
  </div>
</div>
